var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("商品详情")])]),_c('div',{staticClass:"box-content"},[_c('p',[_vm._v("1. 所付订单金额是扣除环保补助或者其他新机活动以后的价格，旧机回收线在完成交易后，打款到该用户")]),_c('p',[_vm._v("2. 支付说明：旧机款项在您旧机到货和完成交易以后，速回收打款到您指定的付款账户")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }